import { Component, Inject, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    ValidationErrors,
    Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { VALIDATOR_EXP } from 'src/environments/constants';
import { RequestType } from 'src/app/model/enums/request-type';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { ProviderInterface } from 'src/app//model/user/provider-interface';
import { Observable, of, timer } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { PaymentData } from 'src/app/model/stripe-models/payment/payment-data';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';

@Component({
    selector: 'app-dialog-tarife',
    templateUrl: './dialog-tarife.component.html',
    styleUrls: ['./dialog-tarife.component.css'],
    standalone: false
})
export class DialogTarifeComponent implements OnInit {
    step: 'tarif' | 'checkout' = 'tarif';
    demoTarifeForm: UntypedFormGroup;

    organisation: AbstractControl
    tarif: AbstractControl
    menge: AbstractControl
    zahlungsart: AbstractControl
    vouchercode: AbstractControl;

    providers$: Observable<ProviderInterface[]>;
    activeProvider$: Observable<ProviderInterface>;
    activeProvider: ProviderInterface;

    companyId: number;
    contactEmail: string[];
    type: RequestType;
    openAGB: any;
    openPrivacy: any;

    showForm: boolean = true;
    showDemoSuccessMessage = false;
    showOfferSuccessMessage = false;
    showListingSuccessMessage = false;
    showErrorMessage = false;
    showNoContactMail = false;
    showWaitForResult = false;
    public memberships;
    paymentDatas: PaymentData[] = [];

    discountPercent: number | null = null;
    selectedPacket: PackageModel | null = null;

    activeOrg: any;
    loading: any = false;

    unitAmount: string;
    subtotalBeforeDiscount: string;
    discountAmount: string | null;
    subtotal: string;
    tax: string;
    total: string;
    monthlySubtotal: string;

    constructor(
        private dialogService: DialogService,
        private cdr: ChangeDetectorRef,
        public dialogRef: MatDialogRef<DialogTarifeComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private formbuilder: UntypedFormBuilder,
        private productService: ProductService,
        private organisationService: OrganisationService,
        private userService: UserService,
        public headerService: HeaderServiceService,
        public router: Router,
        private stripeService: StripeService
    ) {

    }

    ngOnInit(): void {
        this.userService.currentMembershipsObserver.subscribe((memberships) => {
            if (memberships) { this.memberships = memberships; }
        });
        this.activeProvider$ = this.headerService.activeProviderObservable$;
        this.headerService.activeProviderObservable$.subscribe((activeProvider) => {
            this.activeProvider = activeProvider;
        });
        this.activeOrg = this.headerService.activeOrganisation ? this.headerService.activeOrganisation.organisationId : '';
        this.initialiseContactForm();
    }

    onSubmit(): void {
        if (this.demoTarifeForm.valid) {
            this.subscribeAbonnement(this.userService.currentUser.userId, this.organisation.value, this.tarif.value, this.menge.value, this.zahlungsart.value)
        }
    }


    initialiseContactForm(): void {
        this.demoTarifeForm = this.formbuilder.group({
            tarif: [this.data.id, Validators.required],
            organisation: [this.activeOrg, Validators.required],
            menge: ["1", Validators.required],
            zahlungsart: ["", Validators.required],
            //   vouchercode: ["", [Validators.minLength(1), containsAtLeastLettersAndSpecialChars]],
            vouchercode: [""],
        });
        this.organisation = this.demoTarifeForm.controls['organisation'];
        this.tarif = this.demoTarifeForm.controls['tarif'];
        this.menge = this.demoTarifeForm.controls['menge'];
        this.zahlungsart = this.demoTarifeForm.controls['zahlungsart'];
        this.vouchercode = this.demoTarifeForm.controls['vouchercode'];
        this.getPaymentData(this.demoTarifeForm.get('organisation').value);
        this.demoTarifeForm.get('organisation').valueChanges.subscribe(value => { this.getPaymentData(value); });
    }

    getPaymentData(orgId: any) {
        this.stripeService.getPaymentData(orgId.toString(), '')
            .pipe(
                catchError(error => {

                    return of([]);
                })
            )
            .subscribe(data => {
                if (Array.isArray(data)) {
                    this.paymentDatas = data;
                } else {
                    this.paymentDatas = [];
                }
                this.cdr.markForCheck();
            });
    }

    addNewOrganization(): void {
        this.dialogRef.close();
        this.router.navigate(['/profil/mitgliedschaften']);
    }

    addNewZahlungMethod(): void {
        this.dialogRef.close();
        this.headerService.openSettings(this.activeProvider.organisationId);
    }

    addPaymentMethod() {
        if (this.organisation.value) {
            const lastPartUrl = this.router.url.split('/').pop();
            this.stripeService.addPaymentMethod(this.organisation.value.toString(), lastPartUrl).pipe(
                catchError(error => {
                    this.dialogService.openDialog('Hinzufügen einer neuen Zahlungsmethode fehlgeschlagen.', 'Fehler 403: Fehlgeschlagen. Bitte versuchen Sie es später erneut.');
                    return of([]);
                })
            )
                .subscribe(data => {
                    if (typeof data === "string") window.location.href = data;
                    this.cdr.detectChanges();
                });
        }
        else {
            this.dialogService.openDialog('Hinzufügen einer neuen Zahlungsmethode fehlgeschlagen.', 'Der Benutzer ist kein Mitglied einer Organisation.');
        }
    }

    subscribeAbonnement(userId, orgId, packetId, quantity, paymentMethodId): void {
        const voucher = this.vouchercode?.value?.trim();

        this.dialogService
            .openConfirmDialog(
                'Wollen Sie das Abonnement wirklich kaufen?',
                'Abbrechen',
                'Bestätigen'
            )
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.loading = true;

                    this.stripeService.addSubscription(userId, orgId, packetId, quantity, paymentMethodId, voucher || undefined)
                        .pipe(
                            catchError(error => {
                                return of([]);
                            })
                        )
                        .subscribe((data: any) => {
                            this.loading = false;
                            if (typeof data === "string") {
                                const successMessage = voucher && this.discountPercent
                                    ? 'Abonnement erfolgreich – Gutschein wurde eingelöst.'
                                    : 'Neues Abonnement erfolgreich gekauft';

                                this.dialogService.openDialog(successMessage, "Ihr neues Abonnement ist einsatzbereit. Ein Produkt können Sie über den Tab 'Produkte' erstellen oder bearbeiten.");
                                this.dialogRef.close(orgId);
                            } else if (data.status == 401) {
                                this.dialogService.openDialog('Der Kauf eines neuen Abonnements ist fehlgeschlagen.', 'Fehler beim Kauf des neuen Abonnements,');
                                this.dialogRef.close(false);
                            } else {
                                this.dialogService.openDialog('Es ist ein Fehler aufgetreten.', 'Versuchen sie es später noch einmal.');
                                this.dialogRef.close(false);
                            }
                        });
                }
            });
    }

    cancel(): void {
        this.dialogRef.close();
    }

    checkDiscount(couponCode): void {
        if (!couponCode?.trim()) {
            this.proceedToCheckout();
            return;
        }

        this.loading = true;
        this.discountPercent = null;

        const discountCall = this.stripeService.couponDiscount(couponCode, this.activeOrg);
        const validationCall = this.stripeService.validateCoupon(couponCode, this.activeOrg);

        discountCall.subscribe({
            next: (percent) => {
                if (percent === 'invalid' || percent === '0.0') {
                    this.handleInvalidVoucher();
                    return;
                }

                const percentValue = Number(percent);
                if (percentValue && percentValue > 0 && !isNaN(percentValue)) {
                    // Discount ist gültig, jetzt Validierung prüfen
                    validationCall.subscribe({
                        next: (validatedCode) => {
                            this.loading = false;
                            if (validatedCode) {
                                this.discountPercent = percentValue;
                                this.vouchercode.setErrors(null);
                                this.proceedToCheckout();
                            } else {
                                this.handleInvalidVoucher();
                            }
                        },
                        error: (err) => {
                            this.loading = false;
                            this.handleInvalidVoucher();
                        }
                    });
                } else {
                    this.handleInvalidVoucher();
                }
            },
            error: (err) => {
                this.loading = false;
                this.handleInvalidVoucher();
            }
        });
    }

    private handleInvalidVoucher(): void {
        this.loading = false;
        this.vouchercode.setErrors({ invalidVoucher: true });
        this.discountPercent = null;
    }

    getSelectedPacket() {
        if (!this.data?.ProductsToShow || !this.tarif?.value) {
            return null;
        }
        return this.data.ProductsToShow.find(
            (packet) => packet.priceId.id === this.tarif.value
        );
    }

    goToCheckout() {
        if (!this.demoTarifeForm.valid) {
            this.demoTarifeForm.markAllAsTouched();
            return;
        }

        const couponCode = this.demoTarifeForm.get('vouchercode')?.value?.trim();

        if (couponCode) {
            this.checkDiscount(couponCode);
        } else {
            this.discountPercent = null;
            this.proceedToCheckout();
        }
    }

    backToTarif() {
        this.step = 'tarif';
    }

    private proceedToCheckout(): void {
        this.selectedPacket = this.getSelectedPacket();

        if (this.selectedPacket) {
            // const productName =  selectedPacket.productName;
            // const unitAmount = selectedPacket.unitAmount; 
            this.calculatePriceDetails();

            this.step = 'checkout';
        }
    }

    private calculatePriceDetails(): void {
        const unitAmountNum = this.selectedPacket.unitAmount / 100;
        const subtotalNum = unitAmountNum * this.menge.value;

        let discountAmount = 0;
        if (this.discountPercent && this.discountPercent > 0) {
            discountAmount = subtotalNum * (this.discountPercent / 100);
        }

        const discountedSubtotalNum = subtotalNum - discountAmount;
        const taxNum = discountedSubtotalNum * 0.19;
        const totalNum = discountedSubtotalNum + taxNum;

        const monthlySubtotalNum = unitAmountNum / 12;

        this.unitAmount = this.formatCurrency(unitAmountNum);
        this.subtotalBeforeDiscount = this.formatCurrency(subtotalNum);
        this.discountAmount = discountAmount > 0 ? this.formatCurrency(discountAmount) : null;
        this.subtotal = this.formatCurrency(discountedSubtotalNum);
        this.tax = this.formatCurrency(taxNum);
        this.total = this.formatCurrency(totalNum);
        this.monthlySubtotal = this.formatCurrency(monthlySubtotalNum);
    }

    formatCurrency(amount: number): string {
        return amount.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }
}

const letterRegex = new RegExp(VALIDATOR_EXP.CONTAINS_LETTER);
const numberRegex = new RegExp(VALIDATOR_EXP.CONTAINS_NUMBER);
const specialCharRegex = new RegExp(VALIDATOR_EXP.CONTAINS_SPECIAL_CHAR);

function containsLettersButNoNumbers(control: UntypedFormControl): ValidationErrors {
    if (
        control.value !== '' &&
        (!letterRegex.test(control.value) || numberRegex.test(control.value))
    ) {
        return { containsNoLettersOrContainsNumbers: true };
    }
}

function containsAtLeastLettersAndSpecialChars(
    control: UntypedFormControl
): ValidationErrors {
    if (
        control.value !== '' &&
        (!letterRegex.test(control.value) ||
            !specialCharRegex.test(control.value))
    ) {
        return { doesNotContainLettersAndSpecialChars: true };
    }
}

function containsNumbersButNoLetters(control: UntypedFormControl): ValidationErrors {
    if (
        control.value !== '' &&
        (letterRegex.test(control.value) || !numberRegex.test(control.value))
    ) {
        return { containsNotOnlyNumbersAndSpecialChars: true };
    }


}
